spApp.directive('schoolDirective', ['$http', function ($http) {
  return {
    restrict: 'E',
    templateUrl: '/views/filters/school-filter.html',
    scope: {
      selectedStates: '=',
      selectedDistricts: '=',
      selectedSchools: '='
    },
    link: function ($scope) {
      $scope.$watchGroup(['selectedStates', 'selectedDistricts'], () => {
        $scope.getSchoolData();
      });

      $scope.getSchoolData = () => {
        const params = {
          'states[]': $scope.selectedStates,
          'districts[]': $scope.selectedDistricts
        };

        $http.get('/schools/list', {params: params}).then((response) => {
          $scope.schools = response.data;
        });
      }

      $scope.getSchoolData();
      
      $scope.schoolChanged = function () {
        $scope.selectedSchools = $scope.schools.filter(function (item) {
          return item.selected;
        }).map(function (item) {
          return item.id;
        });
      };
    }
  };
}]);
